module.exports = __webpack_public_path__ + "img/wheel.9d2b1589.png";